import React from 'react'
import { createRoot } from 'react-dom/client'
import { setRetryInterval } from 'actions/pending'
import { statusChange } from 'actions/connection'
import Root from 'containers/Root'
import configureStore from 'store/configureStore'
import { setupEmbedMessageHandler } from './embed/messageHandler'

const store = configureStore()
setupEmbedMessageHandler(store)
store.dispatch(setRetryInterval())

const container = document.getElementById('root')!
const root = createRoot(container)
root.render(<Root store={store} />)

window.addEventListener('online', () => store.dispatch(statusChange()))
window.addEventListener('offline', () => store.dispatch(statusChange()))

if (import.meta.env.DEV) {
  import('./demo').then((demo) => {
    ;(window as any).demo = demo
    demo.init(store)
  })
}
